import { z } from 'zod';
import { yesNoUnknownRequired } from '@utils/form-schema';

export const assessHivSchema = z.object({
    hasHiv: yesNoUnknownRequired,
});
